export enum ScormExportFormat {
  SCORM_2004_3 = 'SCORM_2004_3',
  SCORM_2004_4 = 'SCORM_2004_4',
  SCORM_1_2 = 'SCORM_1_2',
  AICC = 'AICC',
  CMI5 = 'CMI5',
  XAPI = 'XAPI',
}
